import "./DaysInputField.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DaysInputField = ({
  placeholder = "",
  name = "",
  isRequired,
  label = null,
  isDisabled = false,
  errorMessage = undefined,
  onChange = () => {},
  value = "",
  register = () => {},
  onKeyUp = () => {},
}) => {
  return (
    <div className="days-input-field">
      {label !== null && (
        <label htmlFor={name}>
          {isRequired && <span className="text-danger">*</span>}
          <span>{label}</span>
        </label>
      )}
      <div
        className={`days-input-field__input-section ${
          errorMessage !== undefined && "error-border"
        }`}
      >
        <input
          type="text"
          name={name}
          id={name}
          placeholder={placeholder}
          disabled={isDisabled}
          defaultChecked={value}
          {...register(name, { required: isRequired })}
          onChange={onChange}
          onKeyUp={onKeyUp}
        />
        <span>Days</span>
      </div>
      <p
        className={`error-message text-danger ${
          errorMessage !== undefined ? "show" : ""
        }`}
      >
        <FontAwesomeIcon
          icon={["fas", "exclamation-circle"]}
          className="mr-2"
          style={{ fontSize: "13px" }}
        />
        {errorMessage !== undefined && <span>{errorMessage.message}</span>}
      </p>
    </div>
  );
};

export default DaysInputField;
